export const facilityRoutes = [
  {
    path: '/facility',
    component: () => import('@/views/facility/facilityDashboard/FacilityDashboard.vue'),
    name: 'FacilityDashboard',
    meta: {
      title: 'Tổng quan Cơ sở vật chất',
      auth: true
    }
  },
  {
    path: '/facility/dashboard',
    redirect: '/facility'
  },
  {
    path: '/facility/categories',
    component: () => import('@/views/facility/facilityCategory/FacilityCategories.vue'),
    name: 'FacilityCategories',
    meta: {
      title: 'Đầu mục thiết bị',
      auth: true
    }
  },
  {
    path: '/facility/assets',
    component: () => import('@/views/facility/facilityAsset/FacilityAssets.vue'),
    name: 'FacilityAssets',
    meta: {
      title: 'Quản lý Thiết bị & Tài sản',
      auth: true
    }
  },
  {
    path: '/facility/locations',
    component: () => import('@/views/facility/facilityLocation/FacilityLocations.vue'),
    name: 'FacilityLocations',
    meta: {
      title: 'Quản lý khu vực & phòng học',
      auth: true
    }
  },
  {
    path: '/facility/inventory',
    component: () => import('@/views/facility/facilityInventory/FacilityInventory.vue'),
    name: 'FacilityInventory',
    meta: {
      title: 'Quản lý kiểm kê',
      auth: true
    }
  },
  {
    path: '/facility/transfers',
    component: () => import('@/views/facility/facilityTransaction/FacilityTransactions.vue'),
    name: 'FacilityTransactions',
    meta: {
      title: 'Xuất nhập & Luân chuyển',
      auth: true
    }
  },
  {
    path: '/facility/borrows',
    component: () => import('@/views/facility/facilityBorrow/FacilityBorrows.vue'),
    name: 'FacilityBorrows',
    meta: {
      title: 'Mượn trả trực tuyến',
      auth: true
    }
  },
  {
    path: '/facility/maintenance',
    component: () => import('@/views/facility/facilityMaintenance/FacilityMaintenance.vue'),
    name: 'FacilityMaintenance',
    meta: {
      title: 'Bảo trì & Sửa chữa',
      auth: true
    }
  },
  {
    path: '/facility/proposals',
    component: () => import('@/views/facility/facilityProposal/FacilityProposals.vue'),
    name: 'FacilityProposals',
    meta: {
      title: 'Đề xuất mua sắm',
      auth: true
    }
  }
]
